module.exports = __webpack_public_path__ + "img/img28.c53e9cf4.svg";